import { supabase } from '../../../integrations/supabase/client';

export interface AgentConfig {
  id?: string;
  user_id: string;
  agent_id?: string;
  system_prompt: string;
  max_mensajes: number;
  tiempo_agrupacion: number;
  instrucciones_kb?: string;
  numero_telefono?: string;
  productos?: string;
  ia_activa?: boolean;
  prompt_calendario?: string;
  onboarding_data?: Record<string, any>;
}

export const saveAgentConfig = async (config: Omit<AgentConfig, 'id' | 'user_id'>) => {
  const { data: { user } } = await supabase.auth.getUser();

  if (!user) {
    throw new Error('Usuario no autenticado');
  }

  const existing = await getAgentConfig(config.agent_id);

  if (existing) {
    const { numero_telefono, ...configWithoutPhone } = config;
    return updateAgentConfig(existing.id, configWithoutPhone);
  }

  const configData = {
    user_id: user.id,
    ...config,
  };

  delete (configData as any).numero_telefono;

  const { data, error } = await supabase
    .from('agent_config')
    .insert(configData)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const updateAgentConfig = async (id: string, config: Partial<AgentConfig>) => {
  const { data, error } = await supabase
    .from('agent_config')
    .update(config)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const getAgentConfig = async (agentId?: string) => {
  const { data: { user } } = await supabase.auth.getUser();

  if (!user) {
    throw new Error('Usuario no autenticado');
  }

  let query = supabase
    .from('agent_config')
    .select('*')
    .eq('user_id', user.id);

  if (agentId) {
    query = query.eq('agent_id', agentId);
  }

  const { data, error } = await query
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  return data;
};
